import ProductHeader from './Header';

export default ProductHeader;
